module.exports = __webpack_public_path__ + "img/kaifazhong.3762a243.png";